/**
 * Navbar Component
 * Purpose: Navigation bar displayed across all pages
 */

import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { isAuthenticated, logout, getCurrentUser } from '../services/api';

const Navbar = () => {
  const navigate = useNavigate();
  const user = getCurrentUser();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="bg-blue-600 text-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <Link to="/" className="text-2xl font-bold">
            📝 MERN Blog
          </Link>

          <div className="flex items-center gap-6">
            {isAuthenticated() ? (
              <>
                <span className="text-sm font-semibold bg-white/20 px-3 py-1 rounded-full">
                  Welcome, {user?.name}!
                </span>
                <Link
                  to="/blogs"
                  className="hover:text-blue-200 transition-smooth font-medium"
                >
                  All Blogs
                </Link>
                <Link
                  to="/create-blog"
                  className="hover:text-blue-200 transition-smooth font-medium"
                >
                  Create Blog
                </Link>
                <Link
                  to="/my-blogs"
                  className="hover:text-blue-200 transition-smooth font-medium"
                >
                  My Blogs
                </Link>
                <button
                  onClick={handleLogout}
                  className="bg-red-500 hover:bg-red-600 px-4 py-2 rounded-lg transition-smooth font-semibold shadow-md"
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="hover:text-blue-200 transition-smooth font-medium"
                >
                  Login
                </Link>
                <Link
                  to="/signup"
                  className="bg-green-500 hover:bg-green-600 px-4 py-2 rounded-lg transition-smooth font-semibold shadow-md"
                >
                  Sign Up
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
